import CommonUtils from "../../../../utils/Common_Utils";
import { ProfessionalAssessmentList } from "../../skill_score/interface/ScoreResponse_Interface";
import "../styles/OverallResultCardStyles.css";
import CalenderIcon from "../../../../assets/images/inventory_dashboard/calender.png";
import ClockIcon from "../../../../assets/images/inventory_dashboard/clock.png";
import ZeroBulb from "../../../inventory_dashboard/assets/bulb_images/bulb0.png";
import LowRedBulb from "../../../inventory_dashboard/assets/bulb_images/lowred.png";
import RedBulb from "../../../inventory_dashboard/assets/bulb_images/RedBulb.png";
import GreenBulb from "../../../inventory_dashboard/assets/bulb_images/GreenBulb.png";
import YellowBulb from "../../../inventory_dashboard/assets/bulb_images/YellowBulb.png";
import LowYellowBulb from "../../../inventory_dashboard/assets/bulb_images/LowYellowBulb.png";
import { GradedPopQuizItem, GradedPopQuizResponse } from "../../../inventory_dashboard/data/interface/AdvancedFilterReponse";
import illustratorImg from "../../../inventory_dashboard/assets/chartillustratorImg.png";
import ArrowImg from "../../../inventory_dashboard/assets/GP_card_Arrow_Img.png";
import VideoImg from "../../../inventory_dashboard/assets/GPVideoImg.png";
import DocImg from "../../../inventory_dashboard/assets/documentIcon.png";

import { Key } from "react";
import { setSelectedToggle } from "../../../../features2/dashboard/data/redux/GradedPopQuizRedux";
import { useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";


interface ProfessionalPageProps {
  data: GradedPopQuizResponse[] | any;
  date?: String;
  assessment_title?: string;
  overall_score?: number;
onViewResultClick: (quiz: GradedPopQuizItem) => void;
  duration?: number;
}

const GradedPopQuizCardPage : React.FC<ProfessionalPageProps> = ({
  data,
  date,
  assessment_title,
  overall_score,
  onViewResultClick=()=>{},
  duration,
}) => {
  const dispatch = useDispatch();
  const getScroeBoardResult = (
    score: number
  ): {
    backgroundColor: string;
    textColor: string;
    bulbImage: string;
    text: string;
  } => {
    let backgroundColor: string;
    let textColor: string;
    let bulbImage: string;
    let text: string;
    if (score === 0) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = ZeroBulb;
      text =
        "Let’s get started! 🚀\nBegin with the first topic and take it one step at a time.";
    } else if (score >= 1 && score <= 10) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Let’s refocus! 📘✨ \nSpend a little more time reviewing the basics.";
    } else if (score >= 11 && score <= 20) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Keep trying! 💪📚 \nIdentify where you’re stuck and revise those topics.";
    } else if (score >= 21 && score <= 30) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Stay consistent! 🔍✨ \nPractice regularly and try solving a few sample questions.";
    } else if (score >= 31 && score <= 40) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = LowRedBulb;
      text =
        "Good effort, but needs more focus! 🎯📘 \nRevise the key concepts daily.";
    } else if (score >= 41 && score <= 50) {
      backgroundColor = "#FFDADA";
      textColor = "#DF3030";
      bulbImage = RedBulb;
      text =
        "Nice attempt! 📈 \nRevisit difficult areas—you’re closer than you think!";
    } else if (score >= 51 && score < 60) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "Great job! 🚀✨\nKeep the momentum going by practicing a bit more each day.";
    } else if (score >=60 && score <= 70) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "Fantastic progress! 🔥✨\nA little more consistency will take you even higher!";
    } else if (score >= 71 && score <80) {
      backgroundColor = "#F7E9AF";
      textColor = "#F7921B";
      bulbImage = LowYellowBulb;
      text =
        "You’re doing great! 🎉 \nBrush up on weak areas to boost your score further.";
    }
    //  else if (score >= 81 && score <= 90) {
    //   backgroundColor = "#F7E9AF";
    //   textColor = "#F7921B";
    //   bulbImage = YellowBulb;
    //   text = "Amazing work! 🌟📘\nKeep up the focus and you’ll reach the top!";
    // } else if (score >= 91 && score <= 99) {
    //   backgroundColor = "#F7E9AF";
    //   textColor = "#F7921B";
    //   bulbImage = YellowBulb;
    //   text = "Outstanding! 🏆✨\nYour hard work shows—excellent performance!";
    // } 
    else {
      backgroundColor = "#CBFAE9";
      text = "Congratulations! You did it 🎉 Keep shining!";
      

      textColor = "#24C782";
      bulbImage = GreenBulb;
    }

    return {
      backgroundColor,
      textColor,
      bulbImage,
      text,
    };
  };
  const overallAvgScore =
  data?.graded_popquiz_data?.length > 0
    ? Math.round(
        data.graded_popquiz_data.reduce(
          (sum: number, item: GradedPopQuizItem) =>
            sum + (item.pop_quiz_avg || 0),
          0
        ) / data.graded_popquiz_data.length
      )
    : 0;

  const formatDuration = (minutes: number): string => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hrs === 0) {
      return `${minutes}m 00s`;
    }

    return `${hrs}hr ${mins}m 00s`;
  };
if (!data.graded_popquiz_data || data.graded_popquiz_data.length === 0) {
  // dispatch(setSelectedToggle("Assessments Results"));
    return (
       <div
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "#999",
                      display: "flex",
                      flexDirection: "column", // stack vertically
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={illustratorImg}
                      style={{
                        height: "400px",
                        width: "470px",
                        marginBottom: "20px",
                      }}
                      alt="No Data"
                    />
                    <span
                      style={{ fontFamily: "MazzardMedium", color: "#272727" }}
                    >
                      No subject score and concepts performance {" "}
                    </span>
                  </div>
    );
  }
  return (
    <>
      <div className="industryresults-grid-container">
       
        {data.graded_popquiz_data.map((record: GradedPopQuizItem, index: Key | null | undefined) => (
          <div
            key={index}
            className="industryresults-grid-item"
            style={{
              backgroundColor: CommonUtils.getIndustryScoreColors(
                record.pop_quiz_avg
              ).backgroundColor,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "20px",
            }}
          >
            {/* Top content */}
            <div>
              <div className="industryresults-score-container">
              {
  record.course_name.length > 52 ? (
    <Tooltip
      title={record.course_name}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#2B2B2B",
            fontSize: "13px",
            fontFamily: "Mazzard",
            borderRadius: "8px",
          },
        },
      }}
    >
      <p
        className="industryresults-percent-title"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          // lineHeight: "20px",
          // maxHeight: "40px",
          wordBreak: "break-word",
        }}
      >
        {record.course_name}
      </p>
    </Tooltip>
  ) : (
    <p
      className="industryresults-percent-title"
      style={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        // lineHeight: "20px",
        // maxHeight: "40px",
        wordBreak: "break-word",
      }}
    >
      {record.course_name}
    </p>
  )
}
              </div>

              <div style={{ padding: "10px 30px" }}>
                <p
                  className="industryresults-percent-score"
                  style={{
                    color: CommonUtils.getIndustryScoreColors(
                      record.pop_quiz_avg
                    ).percentColor,
                  }}
                >
                  {record.pop_quiz_avg} %
                </p>
              </div>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                  onClick={()=>{onViewResultClick(record)}}
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#ffffff",
                    color: "#1A1F24",
                    border: "2px solid #FFC85D",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
View Analytics      <span><img src={ArrowImg} style={{height:"20px",width:"20px"}} /></span>          </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default GradedPopQuizCardPage ;
